import Vuex from 'vuex';
import axios from 'axios';
import Vue from 'vue';

import { refProperties } from './properties';
import { refSynthesis } from './synthesis';
import { refControls } from './controls';
import { conformite } from './forms/conformite';
import { propertyForm } from './forms/property';
import { vpt } from './forms/vpt';
import { ve } from './forms/ve';
import { workflow } from './forms/workflow';
import { mainForm } from './forms/main';
import { router } from '../main.js';
import { DEFAULT_RESPONSE_REQUEST, DEFAULT_GET_RESPONSE_REQUEST } from '../constants/params';
import messageAlert from '../constants/message';
import { getEndpoint } from './endpoints';
import NProgress from 'nprogress';
import trackingContractTemplates from './trackingContractTemplates';
import trackingContractMails from './trackingContractMails';
import trackingContractInvoices from './trackingContractInvoices';
import controlsList from './controlsList';

const app = {
    state: {
        parameters: {},
        http: {
            instance: axios.create(),
            error: {},
        },
        typeForm: null,
        notif: {
            label: null,
            message: null,
        },
    },
    mutations: {
        setParameters(state, payload) {
            state.parameters = payload;
        },
        setHttpInstance(state, payload) {
            state.http.instance = payload;
        },
        setTypeForm(state, payload) {
            state.typeForm = payload;
        },
        setNotif(state, payload) {
            let label = messageAlert.ERROR_LABEL;
            let message = messageAlert.ERROR_CREATION_FORM;

            if (payload && (payload.data.message == DEFAULT_RESPONSE_REQUEST || DEFAULT_GET_RESPONSE_REQUEST)) {
                label = messageAlert.SUCESS_LABEL;
                message = messageAlert.SUCESS_CREATION_FORM;
            }

            state.notif = { label, message };
        },
        initNotif(state) {
            state.notif = { label: null, message: null };
        },
    },
    actions: {
        setParameters({ commit, dispatch }, payload) {
            commit('setParameters', payload);

            dispatch('setHttpInstance');
            dispatch('fetchNetworkTypes');
            dispatch('fetchNetworkProperties');
            dispatch('fetchVisitDisposals');
        },
        setHttpInstance({ commit, state }) {
            const httpInstance = axios.create({
                baseURL: state.parameters.urlApiProperty,
            });
            httpInstance.interceptors.request.use(config  => {
//                console.log('call : '+ config.url);
                NProgress.start();
                return config;
            });

            // before a response is returned stop nprogress
            httpInstance.interceptors.response.use(response => {
                NProgress.done();
//                console.log('end call : '+ response.config.url);
                return response;
            });

            httpInstance.interceptors.response.use(
                response => response,
                error => {
                    Vue.toasted.show('⚠ Erreur 500: Un erreur est survenu lors de la communication avec le serveur. ' + 
                    'Veuillez réessayer dans quelques minutes 🕐', {
                        type: 'error',
                        position: 'top-center',
                    }).goAway(3000);
                    return Promise.reject(error);
                },
            );

            commit('setHttpInstance', httpInstance);
        },
        redirectToDetail({ rootState }) {
            router.push({ name: 'property_detail', params: { propertyId: rootState.refProperties.propertyId } });
        },
        redirectToList() {
            router.push({ name: 'properties' });
        },
        initNotif({ commit }) {
            commit('initNotif');
        },
        async postFormRoute({ rootState, dispatch, commit }, payload) {
            const type = rootState.app.typeForm;
            const initForm = `init${type.charAt(0).toUpperCase()}${type.slice(1)}Form`;

            await rootState.app.http.instance
                .post(payload.endpoint, payload.form, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(
                    response => {
                        commit('setNotif', response);
                        dispatch('fetchProperties');
                        dispatch(initForm);
                        dispatch('redirectToDetail');
                    },
                    errors => {
                        console.log('error', errors.message);
                        commit('setNotif');
                        dispatch('redirectToDetail');
                    }
                );
        },
    },
    getters: {
        getForm(state, getters) {
            switch (state.typeForm) {
                case 'vpt':
                    return getters.getVptForm;
                case 've':
                    return getters.getVeForm;
            }
        },
        getNotif(state) {
            return state.notif;
        },
        getLinkPreviewFileControl: state => payload => {
            const endpoint = getEndpoint('file', null, payload.controlId, payload.fileId).downloadFile;
            return `${state.parameters.urlApiProperty}/${endpoint}`;
        },
        getLinkFileControl: state => payload => {
            const endpoint = getEndpoint('file', null, payload.controlId, payload.fileId).download;
            return `${state.parameters.urlApiProperty}/${endpoint}`;
        },
        getPreviewFileProperty: state => payload => {
            const endpoint = getEndpoint('properties', null, null, payload.fileId).previewFile;
            return `${state.parameters.urlApiProperty}/${endpoint}`;
        },
        getFileProperty: state => payload => {
            const endpoint = getEndpoint('properties', null, null, payload.fileId).download;
            return `${state.parameters.urlApiProperty}/${endpoint}`;
        },
    },
};

export const createStore = plugins =>
    new Vuex.Store({
        plugins,
        modules: {
            app,
            refProperties,
            refSynthesis,
            refControls,
            mainForm,
            conformite,
            vpt,
            ve,
            propertyForm,
            workflow,
            trackingContractTemplates,
            trackingContractMails,
            trackingContractInvoices,
            controlsList,
        },
    });
